(function () {
    'use strict';

    // base: Clave base para el fichero de mensajes.
    // value: Valor.

    var enumerado = {
        template: '{{enumCtrl.base + "." + enumCtrl.value | translate}}',
        controllerAs: 'enumCtrl',
        bindings: {
            value: '@',
            base: '@'
        }
    };

    angular
        .module('app')
        .component('enumerado', enumerado);

})();
